import { ReactNode } from 'react';

export const ProductCardSection = ({
  type = 'name',
  children,
  leading,
  onPress,
}: {
  type?: 'image' | 'badge' | 'name' | 'description' | 'price' | 'action';
  children?: ReactNode;
  leading?: ReactNode;
  onPress?: () => void;
}) => {
  switch (type) {
    case 'image':
      return (
        <div className="aspect-square" onClick={onPress}>
          {children}
        </div>
      );
    case 'badge':
      return <div>{children}</div>;
    case 'name':
      return (
        <div className="mt-3" onClick={onPress}>
          {children}
        </div>
      );
    case 'description':
      return (
        <div className="mt-1" onClick={onPress}>
          {children}
        </div>
      );
    case 'price':
      return (
        <div className="mt-2 flex row items-center gap-2" onClick={onPress}>
          {children}
          {leading && <div className="ml-auto">{leading}</div>}
        </div>
      );
    case 'action':
      return (
        <div className="mt-3 lg:mt-4" onClick={onPress}>
          {children}
        </div>
      );
    default:
      return null;
  }
};
